import React from 'react';
import { type BuyerLayoutProps } from 'shop-ui/types';

interface ProductHeadingProps extends BuyerLayoutProps<Product> {}

export const ProductHeading: React.FC<ProductHeadingProps> = (props) => {
    const { __ssr = {} } = props;

    const { product } = __ssr;

    return (
        <div className="skeleton skeleton--ssr skeleton--md">
            <h1 className="ssr-hidden">{product.name}</h1>
        </div>
    );
};
